import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';

import Home from './Pages/Home/Home';
import About from './Pages/About/About';
import Services from './Pages/Services/Services';
import Sectors from './Pages/Sectors/Sectors';
import CaseStudies from './Pages/CaseStudies/CaseStudies';
import Team from './Pages/Team/Team';
import Contact from './Pages/Contact/Contact';
import Courses from './Pages/Courses/Courses';
import ScrollToAnchor from './Components/Scrollanchor/Scrollanchor';
import AppliedResearch from './Pages/Servicedetail/AppliedResearch';
import Merl from './Pages/Servicedetail/Merl';
import ImplementationResearch from './Pages/Servicedetail/ImplementationResearch';
import DataAnalytics from './Pages/Servicedetail/DataAnalytics';
import StrategyGovernance from './Pages/Servicedetail/StrategyGovernance';
import KnowledgeTranslation from './Pages/Servicedetail/KnowledgeTranslation';
import img1 from './Images/DevLLogo.png'
import Careers from './Pages/Careers/Careers';



import './index.css';
import CourseDetail from './Pages/CourseDetail/CourseDetail';

/* ==================== DROPDOWN DATA ==================== */
// const serviceLinks = [
//   { label: 'Applied Research & Policy Analysis', path: '/services#research' },
//   { label: 'MERL Frameworks', path: '/services#merl' },
//   { label: 'Capacity Development', path: '/services#capacity' },
//   { label: 'Strategy & Technical Assistance', path: '/services#strategy' },
//   { label: 'Knowledge Translation', path: '/services#knowledge' },
// ];
const serviceLinks = [
  { label: 'Applied Research & Policy Analysis', path: '/services/applied-research' },
  { label: 'MERL System', path: '/services/merl#merl' },
   { label: 'Implementation Research & Adaptive Learning', path: '/services/implementation-research' },
  { label: 'Strategy & Capacity Building', path: '/services/strategy-governance' },
  { label: 'Data Analytics', path: '/services/data-analytics' },
  { label: 'Knowledge Translation', path: '/services/knowledge-translation' },
];

  //  <Route path="/services/applied-research" element={<AppliedResearch />} />
  //       <Route path="/services/merl" element={<Merl />} />
  //       <Route path="/services/implementation-research" element={<ImplementationResearch />} />
  //       <Route path="/services/data-analytics" element={<DataAnalytics />} />
  //       <Route path="/services/strategy-governance" element={<StrategyGovernance />} />
  //       <Route path="/services/knowledge-translation" element={<KnowledgeTranslation />} />
  //       <Route path="*" element={<Home />} />

const sectorLinks = [
  { label: 'Domain Specific', path: '/sectors#domain-specific' },
  { label: 'Cross Domain', path: '/sectors#cross-domain' },
];

const teamLinks = [
  { label: 'Leadership', path: '/team#board' },
  { label: 'Management Team', path: '/team#leadership' },
  
  { label: 'Thematic Experts', path: '/team#associates' },
  { label: 'Careers', path: '/careers' },

];

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [sectorsOpen, setSectorsOpen] = useState(false);
  const [teamOpen, setTeamOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const NavLink = ({ to, children }) => (
    <Link
      to={to}
      className="nav-link"
      onClick={() => setMobileMenuOpen(false)}
    >
      {children}
    </Link>
  );

  return (
    <Router>
      
      <ScrollToAnchor />
      {/* ==================== HEADER ==================== */}
      <header className={`header ${scrolled ? 'scrolled' : ''}`}>
        <div className="inner">
          <Link to="/" className="logo">
          <img
            src={img1}
            alt="DevLearn Impact Research"
            className="logo-image"
          />
        </Link>

          {/* <Link to="/" className="logo">
            DevLearn Impact Research
          </Link> */}

          {/* ==================== DESKTOP NAV ==================== */}
          <nav className="nav-desktop">
            {/* SERVICES DROPDOWN */}
            <div className="nav-dropdown">
              <span className="nav-link">
                Services
                <ChevronDown size={16} className="desktop-chevron" />
              </span>
              <div className="dropdown-menu">
                {serviceLinks.map((item, i) => (
                  <Link key={i} to={item.path} className="dropdown-item">
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* SECTORS DROPDOWN */}
            <div className="nav-dropdown">
              <span className="nav-link">
                Thematic Areas
                <ChevronDown size={16} className="desktop-chevron" />
              </span>
              <div className="dropdown-menu">
                {sectorLinks.map((item, i) => (
                  <Link key={i} to={item.path} className="dropdown-item">
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>

            <NavLink to="/case-studies">Projects</NavLink>
            <NavLink to="/courses">Training</NavLink>
            <NavLink to="/about">About</NavLink>

            {/* TEAM DROPDOWN */}
            <div className="nav-dropdown">
              <span className="nav-link">
                Team
                <ChevronDown size={16} className="desktop-chevron" />
              </span>
              <div className="dropdown-menu">
                {teamLinks.map((item, i) => (
                  <Link key={i} to={item.path} className="dropdown-item">
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          </nav>

          <div className="header-actions">
            <NavLink to="/contact">Contact</NavLink>
            <Link to="/contact" className="cta-btn">
              Let's Talk
            </Link>
          </div>

          {/* MOBILE TOGGLE */}
          <button
            className="mobile-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
          </button>
        </div>

        {/* ==================== MOBILE MENU ==================== */}
        <nav className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
          {/* SERVICES EXPAND WITH CHEVRON */}
          <div className="mobile-dropdown">
            <button
              className="mobile-dropdown-toggle"
              onClick={() => setServicesOpen(!servicesOpen)}
            >
              <span>Services</span>
              <ChevronDown 
                size={24} 
                className={`chevron-icon ${servicesOpen ? 'open' : ''}`}
              />
            </button>

            {servicesOpen && (
              <div className="mobile-submenu">
                {serviceLinks.map((item, i) => (
                  <Link
                    key={i}
                    to={item.path}
                    onClick={() => {
                      setMobileMenuOpen(false);
                      setServicesOpen(false);
                    }}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* SECTORS EXPAND WITH CHEVRON */}
          <div className="mobile-dropdown">
            <button
              className="mobile-dropdown-toggle"
              onClick={() => setSectorsOpen(!sectorsOpen)}
            >
              <span>Thematic Areas</span>
              <ChevronDown 
                size={24} 
                className={`chevron-icon ${sectorsOpen ? 'open' : ''}`}
              />
            </button>

            {sectorsOpen && (
              <div className="mobile-submenu">
                {sectorLinks.map((item, i) => (
                  <Link
                    key={i}
                    to={item.path}
                    onClick={() => {
                      setMobileMenuOpen(false);
                      setSectorsOpen(false);
                    }}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            )}
          </div>

          {/* TEAM EXPAND WITH CHEVRON */}
          <div className="mobile-dropdown">
            <button
              className="mobile-dropdown-toggle"
              onClick={() => setTeamOpen(!teamOpen)}
            >
              <span>Team</span>
              <ChevronDown 
                size={24} 
                className={`chevron-icon ${teamOpen ? 'open' : ''}`}
              />
            </button>

            {teamOpen && (
              <div className="mobile-submenu">
                {teamLinks.map((item, i) => (
                  <Link
                    key={i}
                    to={item.path}
                    onClick={() => {
                      setMobileMenuOpen(false);
                      setTeamOpen(false);
                    }}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <NavLink to="/case-studies">Projects</NavLink>
          <NavLink to="/courses">Training</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/contact">Contact</NavLink>

          <Link
            to="/contact"
            className="cta-btn"
            style={{ display: 'inline-block', marginTop: '30px' }}
          >
            Let's Talk
          </Link>
        </nav>
      </header>

      {/* ==================== ROUTES ==================== */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/sectors" element={<Sectors />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services/applied-research" element={<AppliedResearch />} />
        <Route path="/services/merl" element={<Merl />} />
        <Route path="/services/implementation-research" element={<ImplementationResearch />} />
        <Route path="/services/data-analytics" element={<DataAnalytics />} />
        <Route path="/services/strategy-governance" element={<StrategyGovernance />} />
        <Route path="/services/knowledge-translation" element={<KnowledgeTranslation />} />
        <Route path="*" element={<Home />} />
        <Route path="/courses/:courseSlug" element={<CourseDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
// import { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// import { Menu, X, ChevronDown } from 'lucide-react';

// import Home from './Pages/Home/Home';
// import About from './Pages/About/About';
// import Services from './Pages/Services/Services';
// import Sectors from './Pages/Sectors/Sectors';
// import CaseStudies from './Pages/CaseStudies/CaseStudies';
// import Team from './Pages/Team/Team';
// import Contact from './Pages/Contact/Contact';
// import Courses from './Pages/Courses/Courses';

// /* ==================== DROPDOWN DATA ==================== */
// const serviceLinks = [
//   { label: 'Applied Research & Policy Analysis', path: '/services#research' },
//   { label: 'MERL Frameworks', path: '/services#merl' },
//   { label: 'Capacity Development', path: '/services#capacity' },
//   { label: 'Strategy & Technical Assistance', path: '/services#strategy' },
//   { label: 'Knowledge Translation', path: '/services#knowledge' },
// ];

// const sectorLinks = [
//   { label: 'Domain Specific', path: '/sectors#domain-specific' },
//   { label: 'Cross Domain', path: '/sectors#cross-domain' },
// ];

// function App() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [servicesOpen, setServicesOpen] = useState(false);
//   const [sectorsOpen, setSectorsOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const NavLink = ({ to, children }) => (
//     <Link
//       to={to}
//       className="nav-link"
//       onClick={() => setMobileMenuOpen(false)}
//     >
//       {children}
//     </Link>
//   );

//   return (
//     <Router>
//       {/* ==================== HEADER ==================== */}
//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="inner">
//           <Link to="/" className="logo">
//             DevLearn Research
//           </Link>

//           {/* ==================== DESKTOP NAV ==================== */}
//           <nav className="nav-desktop">
//             {/* SERVICES DROPDOWN */}
//             {/* SERVICES DROPDOWN */}
//             <div className="nav-dropdown">
//               <span className="nav-link">
//                 Services
//                 <ChevronDown size={16} className="desktop-chevron" />
//               </span>
//               <div className="dropdown-menu">
//                 {serviceLinks.map((item, i) => (
//                   <Link key={i} to={item.path} className="dropdown-item">
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             </div>
//             {/* <div className="nav-dropdown">
//               <span className="nav-link">Services</span>
//               <div className="dropdown-menu">
//                 {serviceLinks.map((item, i) => (
//                   <Link key={i} to={item.path} className="dropdown-item">
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             </div> */}

//             {/* SECTORS DROPDOWN */}
//             {/* SECTORS DROPDOWN */}
//           <div className="nav-dropdown">
//             <span className="nav-link">
//               Thematic Areas
//               <ChevronDown size={16} className="desktop-chevron" />
//             </span>
//             <div className="dropdown-menu">
//               {sectorLinks.map((item, i) => (
//                 <Link key={i} to={item.path} className="dropdown-item">
//                   {item.label}
//                 </Link>
//               ))}
//             </div>
//           </div>
            
//             {/* <div className="nav-dropdown">
//               <span className="nav-link">Thematic Areas</span>
//               <div className="dropdown-menu">
//                 {sectorLinks.map((item, i) => (
//                   <Link key={i} to={item.path} className="dropdown-item">
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             </div> */}

//             <NavLink to="/case-studies">Projects</NavLink>
//             <NavLink to="/courses">Courses</NavLink>
//             <NavLink to="/about">About</NavLink>
//             <NavLink to="/team">Team</NavLink>
//           </nav>

//           <div className="header-actions">
//             <NavLink to="/contact">Contact</NavLink>
//             <Link to="/contact" className="cta-btn">
//               Let's Talk
//             </Link>
//           </div>

//           {/* MOBILE TOGGLE */}
//           <button
//             className="mobile-toggle"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
//           </button>
//         </div>

//         {/* ==================== MOBILE MENU ==================== */}
//         <nav className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//           {/* SERVICES EXPAND WITH CHEVRON */}
//           <div className="mobile-dropdown">
//             <button
//               className="mobile-dropdown-toggle"
//               onClick={() => setServicesOpen(!servicesOpen)}
//             >
//               <span>Services</span>
//               <ChevronDown 
//                 size={24} 
//                 className={`chevron-icon ${servicesOpen ? 'open' : ''}`}
//               />
//             </button>

//             {servicesOpen && (
//               <div className="mobile-submenu">
//                 {serviceLinks.map((item, i) => (
//                   <Link
//                     key={i}
//                     to={item.path}
//                     onClick={() => {
//                       setMobileMenuOpen(false);
//                       setServicesOpen(false);
//                     }}
//                   >
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* SECTORS EXPAND WITH CHEVRON */}
//           <div className="mobile-dropdown">
//             <button
//               className="mobile-dropdown-toggle"
//               onClick={() => setSectorsOpen(!sectorsOpen)}
//             >
//               <span>Thematic Areas</span>
//               <ChevronDown 
//                 size={24} 
//                 className={`chevron-icon ${sectorsOpen ? 'open' : ''}`}
//               />
//             </button>

//             {sectorsOpen && (
//               <div className="mobile-submenu">
//                 {sectorLinks.map((item, i) => (
//                   <Link
//                     key={i}
//                     to={item.path}
//                     onClick={() => {
//                       setMobileMenuOpen(false);
//                       setSectorsOpen(false);
//                     }}
//                   >
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <NavLink to="/case-studies">Projects</NavLink>
//           <NavLink to="/courses">Courses</NavLink>
//           <NavLink to="/about">About</NavLink>
//           <NavLink to="/team">Team</NavLink>
//           <NavLink to="/contact">Contact</NavLink>

//           <Link
//             to="/contact"
//             className="cta-btn"
//             style={{ display: 'inline-block', marginTop: '30px' }}
//           >
//             Let's Talk
//           </Link>
//         </nav>
//       </header>

//       {/* ==================== ROUTES ==================== */}
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/sectors" element={<Sectors />} />
//         <Route path="/case-studies" element={<CaseStudies />} />
//         <Route path="/courses" element={<Courses />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/team" element={<Team />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="*" element={<Home />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
// import { useState, useEffect } from 'react';
// import { Menu, X, ChevronDown } from 'lucide-react';

// /* Mock Router components for demo */
// const Router = ({ children }) => <div>{children}</div>;
// const Routes = ({ children }) => children;
// const Route = () => null;
// const Link = ({ to, children, className, style, onClick }) => (
//   <a href={to} className={className} style={style} onClick={(e) => { e.preventDefault(); onClick?.(); }}>
//     {children}
//   </a>
// );

// /* ==================== SERVICES DROPDOWN DATA ==================== */
// const serviceLinks = [
//   { label: 'Applied Research & Policy Analysis', path: '/services#research' },
//   { label: 'MERL Frameworks', path: '/services#merl' },
//   { label: 'Capacity Development', path: '/services#capacity' },
//   { label: 'Strategy & Technical Assistance', path: '/services#strategy' },
//   { label: 'Knowledge Translation', path: '/services#knowledge' },
// ];

// function App() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [servicesOpen, setServicesOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const NavLink = ({ to, children }) => (
//     <Link
//       to={to}
//       className="nav-link"
//       onClick={() => setMobileMenuOpen(false)}
//     >
//       {children}
//     </Link>
//   );

//   return (
//     <Router>
//       <style>{`
//         /* ==================== RESET & BASE ==================== */
//         *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
//         html { scroll-behavior: smooth; }
//         body {
//           font-family: 'Poppins', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
//           line-height: 1.6;
//           color: var(--text-primary);
//           background: var(--bg-main);
//           -webkit-font-smoothing: antialiased;
//         }
//         h1, h2, h3, h4, h5 { font-weight: 700; letter-spacing: -0.03em; line-height: 1.1; }
//         a { text-decoration: none; color: inherit; }
//         img { max-width: 100%; display: block; }

//         /* ==================== BRAND SYSTEM ==================== */
//         :root {
//           --brand-primary: #9E1F63;
//           --brand-secondary: #F7941D;
//           --brand-accent: #FBB040;
//           --brand-soft: #BA477C;
//           --bg-main: #ffffff;
//           --bg-soft: #FFF6FA;
//           --bg-dark: #2A0F1D;
//           --text-primary: #2B0A1A;
//           --text-secondary: #6B4A57;
//           --text-inverse: #ffffff;
//         }

//         /* ==================== HEADER ==================== */
//         .header {
//           position: fixed;
//           top: 0; left: 0; right: 0;
//           z-index: 1000;
//           height: 80px;
//           background: rgba(255,255,255,0.96);
//           backdrop-filter: blur(20px);
//           border-bottom: 1px solid rgba(158,31,99,0.15);
//           transition: all 0.3s;
//         }
//         .header.scrolled {
//           background: rgba(255,255,255,0.98);
//           box-shadow: 0 2px 12px rgba(158,31,99,0.12);
//         }
//         .header .inner {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 0 40px;
//           height: 100%;
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           gap: 20px;
//         }
//         .logo {
//           font-size: 24px;
//           font-weight: 800;
//           letter-spacing: -0.5px;
//           color: var(--brand-primary);
//           white-space: nowrap;
//         }
//         .nav-desktop {
//           display: flex;
//           gap: 32px;
//           font-size: 16px;
//           font-weight: 500;
//           align-items: center;
//         }
//         .nav-desktop a, .nav-link {
//           position: relative;
//           transition: color 0.2s;
//           cursor: pointer;
//         }
//         .nav-desktop a:hover, .nav-link:hover { color: var(--brand-secondary); }
//         .nav-desktop a::after {
//           content: '';
//           position: absolute;
//           bottom: -8px;
//           left: 0;
//           width: 0;
//           height: 2px;
//           background: var(--brand-secondary);
//           transition: width 0.3s;
//         }
//         .nav-desktop a:hover::after { width: 100%; }
//         .header-actions {
//           display: flex;
//           align-items: center;
//           gap: 24px;
//         }
//         .cta-btn {
//           background: var(--brand-secondary);
//           color: var(--text-inverse);
//           padding: 10px 26px;
//           border-radius: 50px;
//           font-weight: 600;
//           font-size: 15px;
//           transition: all 0.3s;
//         }
//         .cta-btn:hover { background: var(--brand-accent); color: var(--text-primary); }

//         /* ==================== DROPDOWN ==================== */
//         .nav-dropdown {
//           position: relative;
//         }
//         .nav-dropdown:hover .dropdown-menu {
//           opacity: 1;
//           visibility: visible;
//           transform: translateY(0);
//         }
//         .dropdown-menu {
//           position: absolute;
//           top: 42px;
//           left: 0;
//           min-width: 260px;
//           background: #fff;
//           border-radius: 16px;
//           padding: 14px 0;
//           box-shadow: 0 20px 50px rgba(158,31,99,0.18);
//           opacity: 0;
//           visibility: hidden;
//           transform: translateY(10px);
//           transition: all 0.25s ease;
//           z-index: 1000;
//         }
//         .dropdown-item {
//           display: block;
//           padding: 12px 22px;
//           font-size: 15px;
//           color: var(--text-primary);
//           transition: background 0.2s, color 0.2s;
//         }
//         .dropdown-item:hover {
//           background: var(--bg-soft);
//           color: var(--brand-primary);
//         }

//         /* ==================== MOBILE MENU ==================== */
//         .mobile-toggle { 
//           display: none; 
//           font-size: 28px; 
//           cursor: pointer; 
//           background: none;
//           border: none;
//           color: var(--brand-primary);
//         }
//         .mobile-menu {
//           position: absolute;
//           top: 80px; left: 0; right: 0;
//           background: var(--bg-main);
//           border-top: 1px solid #eee;
//           padding: 50px 40px;
//           display: none;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.1);
//         }
//         .mobile-menu.open { display: block; }
//         .mobile-menu a {
//           display: block;
//           font-size: 22px;
//           font-weight: 500;
//           margin-bottom: 24px;
//           transition: color 0.2s;
//         }
//         .mobile-menu a:hover {
//           color: var(--brand-secondary);
//         }

//         /* ==================== MOBILE DROPDOWN ==================== */
//         .mobile-dropdown {
//           margin-bottom: 24px;
//         }
//         .mobile-dropdown-toggle {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           width: 100%;
//           font-size: 22px;
//           font-weight: 500;
//           background: none;
//           border: none;
//           color: var(--text-primary);
//           cursor: pointer;
//           padding: 0;
//           text-align: left;
//           font-family: inherit;
//           transition: color 0.2s;
//         }
//         .mobile-dropdown-toggle:hover {
//           color: var(--brand-secondary);
//         }
//         .chevron-icon {
//           transition: transform 0.3s ease;
//           color: var(--brand-secondary);
//         }
//         .chevron-icon.open {
//           transform: rotate(180deg);
//         }
//         .mobile-submenu {
//           margin-top: 16px;
//           padding-left: 20px;
//           border-left: 2px solid var(--brand-soft);
//         }
//         .mobile-submenu a {
//           font-size: 18px;
//           font-weight: 400;
//           margin-bottom: 16px;
//           color: var(--text-secondary);
//         }
//         .mobile-submenu a:hover {
//           color: var(--brand-primary);
//         }

//         /* ==================== RESPONSIVE ==================== */
//         @media (max-width: 768px) {
//           .nav-desktop, .header-actions > a:not(.cta-btn) { display: none; }
//           .mobile-toggle { display: block; }
//           .header .inner { padding: 0 20px; }
//         }

//         /* Demo content */
//         .demo-content {
//           margin-top: 100px;
//           padding: 40px;
//           text-align: center;
//         }
//         .demo-content h1 {
//           font-size: 48px;
//           color: var(--brand-primary);
//           margin-bottom: 20px;
//         }
//         .demo-content p {
//           font-size: 20px;
//           color: var(--text-secondary);
//         }
//       `}</style>

//       {/* ==================== HEADER ==================== */}
//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="inner">
//           <Link to="/" className="logo">
//             DevLearn Research
//           </Link>

//           {/* ==================== DESKTOP NAV ==================== */}
//           <nav className="nav-desktop">
//             <div className="nav-dropdown">
//               <span className="nav-link">Services</span>
//               <div className="dropdown-menu">
//                 {serviceLinks.map((item, i) => (
//                   <Link key={i} to={item.path} className="dropdown-item">
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             </div>
//             <NavLink to="/sectors">Thematic Areas</NavLink>
//             <NavLink to="/case-studies">Projects</NavLink>
//             <NavLink to="/courses">Courses</NavLink>
//             <NavLink to="/about">About</NavLink>
//             <NavLink to="/team">Team</NavLink>
//           </nav>

//           <div className="header-actions">
//             <NavLink to="/contact">Contact</NavLink>
//             <Link to="/contact" className="cta-btn">
//               Let's Talk
//             </Link>
//           </div>

//           {/* MOBILE TOGGLE */}
//           <button
//             className="mobile-toggle"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
//           </button>
//         </div>

//         {/* ==================== MOBILE MENU ==================== */}
//         <nav className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//           {/* SERVICES EXPAND WITH CHEVRON */}
//           <div className="mobile-dropdown">
//             <button
//               className="mobile-dropdown-toggle"
//               onClick={() => setServicesOpen(!servicesOpen)}
//             >
//               <span>Services</span>
//               <ChevronDown 
//                 size={24} 
//                 className={`chevron-icon ${servicesOpen ? 'open' : ''}`}
//               />
//             </button>

//             {servicesOpen && (
//               <div className="mobile-submenu">
//                 {serviceLinks.map((item, i) => (
//                   <Link
//                     key={i}
//                     to={item.path}
//                     onClick={() => {
//                       setMobileMenuOpen(false);
//                       setServicesOpen(false);
//                     }}
//                   >
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <NavLink to="/sectors">Thematic Areas</NavLink>
//           <NavLink to="/case-studies">Projects</NavLink>
//           <NavLink to="/courses">Courses</NavLink>
//           <NavLink to="/about">About</NavLink>
//           <NavLink to="/team">Team</NavLink>
//           <NavLink to="/contact">Contact</NavLink>

//           <Link
//             to="/contact"
//             className="cta-btn"
//             style={{ display: 'inline-block', marginTop: '30px' }}
//           >
//             Let's Talk
//           </Link>
//         </nav>
//       </header>

//       {/* Demo Content */}
//       <div className="demo-content">
//         <h1>Mobile Menu Demo</h1>
//         <p>Resize your browser to see the mobile menu with chevron indicator</p>
//       </div>
//     </Router>
//   );
// }

// export default App;





// import { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// import { Menu, X } from 'lucide-react';

// import Home from './Pages/Home/Home';
// import About from './Pages/About/About';
// import Services from './Pages/Services/Services';
// import Sectors from './Pages/Sectors/Sectors';
// import CaseStudies from './Pages/CaseStudies/CaseStudies';
// import Team from './Pages/Team/Team';
// import Contact from './Pages/Contact/Contact';
// import Courses from './Pages/Courses/Courses';

// import './index.css';

// /* ==================== SERVICES DROPDOWN DATA ==================== */
// const serviceLinks = [
//   { label: 'Applied Research & Policy Analysis', path: '/services#research' },
//   { label: 'MERL Frameworks', path: '/services#merl' },
//   { label: 'Capacity Development', path: '/services#capacity' },
//   { label: 'Strategy & Technical Assistance', path: '/services#strategy' },
//   { label: 'Knowledge Translation', path: '/services#knowledge' },
// ];

// /* ==================== THEMATIC AREAS DROPDOWN DATA ==================== */
// const thematicLinks = [
//   { label: 'Domain-Specific', path: '/sectors#domain-specific' },
//   { label: 'Cross-Thematic', path: '/sectors#cross-thematic' },
// ];

// function App() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [servicesOpen, setServicesOpen] = useState(false);
//   const [thematicOpen, setThematicOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const NavLink = ({ to, children }) => (
//     <Link
//       to={to}
//       className="nav-link"
//       onClick={() => setMobileMenuOpen(false)}
//     >
//       {children}
//     </Link>
//   );

//   return (
//     <Router>
//       {/* ==================== HEADER ==================== */}
//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="inner">
//           <Link to="/" className="logo">
//             DevLearn Research
//           </Link>

//           {/* ==================== DESKTOP NAV ==================== */}
//           <nav className="nav-desktop">
//             {/* SERVICES DROPDOWN */}
//             <div className="nav-dropdown">
//               <span className="nav-link">Services</span>
//               <div className="dropdown-menu">
//                 {serviceLinks.map((item, i) => (
//                   <Link key={i} to={item.path} className="dropdown-item">
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             </div>

//             {/* THEMATIC AREAS DROPDOWN */}
//             <div className="nav-dropdown">
//               <span className="nav-link">Thematic Areas</span>
//               <div className="dropdown-menu">
//                 {thematicLinks.map((item, i) => (
//                   <Link key={i} to={item.path} className="dropdown-item">
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             </div>

//             <NavLink to="/case-studies">Projects</NavLink>
//             <NavLink to="/courses">Courses</NavLink>
//             <NavLink to="/about">About</NavLink>
//             <NavLink to="/team">Team</NavLink>
//           </nav>

//           <div className="header-actions">
//             <NavLink to="/contact">Contact</NavLink>
//             <Link to="/contact" className="cta-btn">
//               Let's Talk
//             </Link>
//           </div>

//           {/* MOBILE TOGGLE */}
//           <button
//             className="mobile-toggle"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
//           </button>
//         </div>

//         {/* ==================== MOBILE MENU ==================== */}
//         <nav className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//           {/* SERVICES MOBILE DROPDOWN */}
//           <div className="mobile-dropdown">
//             <button
//               className="mobile-dropdown-toggle"
//               onClick={() => setServicesOpen(!servicesOpen)}
//             >
//               Services
//             </button>

//             {servicesOpen && (
//               <div className="mobile-submenu">
//                 {serviceLinks.map((item, i) => (
//                   <Link
//                     key={i}
//                     to={item.path}
//                     onClick={() => {
//                       setMobileMenuOpen(false);
//                       setServicesOpen(false);
//                     }}
//                   >
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* THEMATIC AREAS MOBILE DROPDOWN */}
//           <div className="mobile-dropdown">
//             <button
//               className="mobile-dropdown-toggle"
//               onClick={() => setThematicOpen(!thematicOpen)}
//             >
//               Thematic Areas
//             </button>

//             {thematicOpen && (
//               <div className="mobile-submenu">
//                 {thematicLinks.map((item, i) => (
//                   <Link
//                     key={i}
//                     to={item.path}
//                     onClick={() => {
//                       setMobileMenuOpen(false);
//                       setThematicOpen(false);
//                     }}
//                   >
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <NavLink to="/case-studies">Projects</NavLink>
//           <NavLink to="/courses">Courses</NavLink>
//           <NavLink to="/about">About</NavLink>
//           <NavLink to="/team">Team</NavLink>
//           <NavLink to="/contact">Contact</NavLink>

//           <Link
//             to="/contact"
//             className="cta-btn"
//             style={{ display: 'inline-block', marginTop: '30px' }}
//           >
//             Let's Talk
//           </Link>
//         </nav>
//       </header>

//       {/* ==================== ROUTES ==================== */}
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/sectors" element={<Sectors />} />
//         <Route path="/case-studies" element={<CaseStudies />} />
//         <Route path="/courses" element={<Courses />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/team" element={<Team />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="*" element={<Home />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

//real

// import { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// import { Menu, X } from 'lucide-react';

// import Home from './Pages/Home/Home';
// import About from './Pages/About/About';
// import Services from './Pages/Services/Services';
// import Sectors from './Pages/Sectors/Sectors';
// import CaseStudies from './Pages/CaseStudies/CaseStudies';
// import Team from './Pages/Team/Team';
// import Contact from './Pages/Contact/Contact';
// import Courses from './Pages/Courses/Courses';

// import './index.css';

// /* ==================== SERVICES DROPDOWN DATA ==================== */
// const serviceLinks = [
//   { label: 'Applied Research & Policy Analysis', path: '/services#research' },
//   { label: 'MERL Frameworks', path: '/services#merl' },
//   { label: 'Capacity Development', path: '/services#capacity' },
//   { label: 'Strategy & Technical Assistance', path: '/services#strategy' },
//   { label: 'Knowledge Translation', path: '/services#knowledge' },
// ];

// function App() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [servicesOpen, setServicesOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const NavLink = ({ to, children }) => (
//     <Link
//       to={to}
//       className="nav-link"
//       onClick={() => setMobileMenuOpen(false)}
//     >
//       {children}
//     </Link>
//   );

//   return (
//     <Router>
//       {/* ==================== HEADER ==================== */}
//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="inner">
//           <Link to="/" className="logo">
//             DevLearn Research
//           </Link>

//           {/* ==================== DESKTOP NAV ==================== */}
//           <nav className="nav-desktop">
//             {/* SERVICES DROPDOWN */}
//             <div className="nav-dropdown">
//               <span className="nav-link">Services</span>
//               <div className="dropdown-menu">
//                 {serviceLinks.map((item, i) => (
//                   <Link key={i} to={item.path} className="dropdown-item">
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             </div>

//             <NavLink to="/sectors">Thematic Areas</NavLink>
//             <NavLink to="/case-studies">Projects</NavLink>
//             <NavLink to="/courses">Courses</NavLink>
//             <NavLink to="/about">About</NavLink>
//             <NavLink to="/team">Team</NavLink>
//           </nav>

//           <div className="header-actions">
//             <NavLink to="/contact">Contact</NavLink>
//             <Link to="/contact" className="cta-btn">
//               Let's Talk
//             </Link>
//           </div>

//           {/* MOBILE TOGGLE */}
//           <button
//             className="mobile-toggle"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
//           </button>
//         </div>

//         {/* ==================== MOBILE MENU ==================== */}
//         <nav className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//           {/* SERVICES EXPAND */}
//           <div className="mobile-dropdown">
//             <button
//               className="mobile-dropdown-toggle"
//               onClick={() => setServicesOpen(!servicesOpen)}
//             >
//               Services
//             </button>

//             {servicesOpen && (
//               <div className="mobile-submenu">
//                 {serviceLinks.map((item, i) => (
//                   <Link
//                     key={i}
//                     to={item.path}
//                     onClick={() => {
//                       setMobileMenuOpen(false);
//                       setServicesOpen(false);
//                     }}
//                   >
//                     {item.label}
//                   </Link>
//                 ))}
//               </div>
//             )}
//           </div>

//           <NavLink to="/sectors">Thematic Areas</NavLink>
//           <NavLink to="/case-studies">Projects</NavLink>
//           <NavLink to="/courses">Courses</NavLink>
//           <NavLink to="/about">About</NavLink>
//           <NavLink to="/team">Team</NavLink>
//           <NavLink to="/contact">Contact</NavLink>

//           <Link
//             to="/contact"
//             className="cta-btn"
//             style={{ display: 'inline-block', marginTop: '30px' }}
//           >
//             Let's Talk
//           </Link>
//         </nav>
//       </header>

//       {/* ==================== ROUTES ==================== */}
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/sectors" element={<Sectors />} />
//         <Route path="/case-studies" element={<CaseStudies />} />
//         <Route path="/courses" element={<Courses />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/team" element={<Team />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="*" element={<Home />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// // src/App.js - Updated with Courses page in navbar
// import { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// import { Menu, X } from 'lucide-react';
// import Home from './Pages/Home/Home';
// import About from './Pages/About/About';
// import Services from './Pages/Services/Services';
// import Sectors from './Pages/Sectors/Sectors';
// import CaseStudies from './Pages/CaseStudies/CaseStudies';
// import Team from './Pages/Team/Team';
// import Contact from './Pages/Contact/Contact';
// import Courses from './Pages/Courses/Courses'; // ✅ Import Courses page
// import './index.css'; // Global styles with palette & fixes

// function App() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const NavLink = ({ to, children, className = '' }) => (
//     <Link
//       to={to}
//       className={`nav-link ${className}`}
//       onClick={() => setMobileMenuOpen(false)}
//     >
//       {children}
//     </Link>
//   );

//   return (
//     <Router>
//       {/* Shared Header/Navbar */}
//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="inner">
//           <Link to="/" className="logo">
//             DevLearn Research
//           </Link>
//           <nav className="nav-desktop">
//             <NavLink to="/services">Services</NavLink>
//             <NavLink to="/sectors">Thematic Areas</NavLink>
//             <NavLink to="/case-studies">Projects</NavLink>
//             <NavLink to="/courses">Courses</NavLink> {/* ✅ Added Courses */}
//             <NavLink to="/about">About</NavLink>
//             <NavLink to="/team">Team</NavLink>
//           </nav>
//           <div className="header-actions">
//             <NavLink to="/contact">Contact</NavLink>
//             <a href="/contact" className="cta-btn">
//               Let's Talk
//             </a>
//           </div>
//           <button
//             className="mobile-toggle"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
//           </button>
//         </div>
//         <nav className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//           <NavLink to="/services">Services</NavLink>
//           <NavLink to="/sectors">Thematic Areas</NavLink>
//           <NavLink to="/case-studies">Projects</NavLink>
//           <NavLink to="/courses">Courses</NavLink> {/* ✅ Mobile menu */}
//           <NavLink to="/about">About</NavLink>
//           <NavLink to="/team">Team</NavLink>
//           <NavLink to="/contact">Contact</NavLink>
//           <a
//             href="/contact"
//             className="cta-btn"
//             style={{ display: 'inline-block', marginTop: '30px' }}
//           >
//             Let's Talk
//           </a>
//         </nav>
//       </header>

//       {/* Routes */}
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/sectors" element={<Sectors />} />
//         <Route path="/case-studies" element={<CaseStudies />} />
//         <Route path="/team" element={<Team />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/courses" element={<Courses />} /> {/* ✅ Courses route */}
//         <Route path="*" element={<Home />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
// // src/App.js - Updated with DevLearn branding and fixed navbar alignment
// import { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// import { Menu, X, ArrowRight } from 'lucide-react';
// import Home from './Pages/Home/Home';
// import About from './Pages/About/About';
// import Services from './Pages/Services/Services';
// import Sectors from './Pages/Sectors/Sectors';
// import CaseStudies from './Pages/CaseStudies/CaseStudies';
// import Team from './Pages/Team/Team';
// import Contact from './Pages/Contact/Contact';
// import './index.css'; // Global styles with palette & fixes

// function App() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const NavLink = ({ to, children, className = '' }) => (
//     <Link
//       to={to}
//       className={`nav-link ${className}`}
//       onClick={() => setMobileMenuOpen(false)}
//     >
//       {children}
//     </Link>
//   );

//   return (
//     <Router>
//       {/* Shared Header/Navbar - Fixed alignment */}
//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="inner">
//           <Link to="/" className="logo">
//             DevLearn Research 
//           </Link>
//           <nav className="nav-desktop">
//             <NavLink to="/services">Services</NavLink>
//             <NavLink to="/sectors">Thematic Areas</NavLink>
//             <NavLink to="/case-studies">Projects</NavLink>
//             <NavLink to="/about">About</NavLink>
//             <NavLink to="/team">Team</NavLink>
//           </nav>
//           <div className="header-actions">
//             <NavLink to="/contact">Contact</NavLink>
//             <a href="#" className="cta-btn">
//               Let's Talk
//             </a>
//           </div>
//           <button
//             className="mobile-toggle"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
//           </button>
//         </div>
//         <nav className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//           <NavLink to="/services">Services</NavLink>
//           <NavLink to="/sectors">Thematic Areas</NavLink>
//           <NavLink to="/case-studies">Projects</NavLink>
//           <NavLink to="/about">About</NavLink>
//           <NavLink to="/team">Team</NavLink>
//           <NavLink to="/contact">Contact</NavLink>
//           <a
//             href="/contact"
//             className="cta-btn"
//             style={{ display: 'inline-block', marginTop: '30px' }}
//           >
//             Let's Talk
//           </a>
//         </nav>
//       </header>

//       {/* Routes */}
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/services" element={<Services />} />
//         <Route path="/sectors" element={<Sectors />} />
//         <Route path="/case-studies" element={<CaseStudies />} />
//         <Route path="/team" element={<Team />} />
//         <Route path="/contact" element={<Contact />} />
//         <Route path="*" element={<Home />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
// // src/App.js - Main app with shared navbar and routing
// import { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// import { Menu, X } from 'lucide-react';
// import Home from './Pages/Home/Home'; // Adjust path if your Home is elsewhere

// //import About from './pages/About/About';
// // About
// import './index.css'; // Global styles
// import About from './Pages/About/About';
// import Sectors from './Pages/Sectors/Sectors';
// import Services from './Pages/Services/Services';
// import Contact from './Pages/Contact/Contact';
// import Team from './Pages/Team/Team';
// import CaseStudies from './Pages/CaseStudies/CaseStudies';




// function App() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const NavLink = ({ to, children, className = '' }) => (
//     <Link
//       to={to}
//       className={`nav-link ${className}`}
//       onClick={() => setMobileMenuOpen(false)}
//     >
//       {children}
//     </Link>
//   );

//   return (
//     <Router>
//       {/* Shared Header/Navbar - Fixed on all pages */}
//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="inner">
//           <Link to="/" className="logo">
//             DevLearn Research
//           </Link>
//           <nav className="nav-desktop">
//             <NavLink to="/services">Services</NavLink>
//             <NavLink to="/sectors">Sectors</NavLink>
//             <NavLink to="/case-studies">Case Studies</NavLink>
//             <NavLink to="/Team">Team</NavLink>
//             <NavLink to="/about">About</NavLink>
//           </nav>
//           <div className="header-actions">
//             <NavLink to="/contact">Contact</NavLink>
//             <a href="#" className="cta-btn">
//               Let's talk
//             </a>
//           </div>
//           <button
//             className="mobile-toggle"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
//           </button>
//         </div>
//         <nav className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//           <NavLink to="/services">Services</NavLink>
//           <NavLink to="/sectors">Sectors</NavLink>
//           <NavLink to="/case-studies">Case Studies</NavLink>
//           <NavLink to="/Team">Team</NavLink>
//           <NavLink to="/about">About</NavLink>
//           <NavLink to="/contact">Contact</NavLink>
//           <a
//             href="#"
//             className="cta-btn"
//             style={{ display: 'inline-block', marginTop: '30px' }}
//           >
//             Let's talk
//           </a>
//         </nav>
//       </header>

//       {/* Routes - Swap page content below navbar */}
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/sectors" element={<Sectors />} />
//        <Route path="/services" element={<Services />} /> 
//         <Route path="*" element={<Home />} /> {/* Fallback to home */}
//         <Route path="/contact" element={<Contact />} />
//         <Route path="/team" element={<Team />} />
//         <Route path="/case-studies" element={<CaseStudies />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
// // Updated App.js
// import { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// import { Menu, X, ArrowRight } from 'lucide-react';
// // import Home from './Home'; // Rename your original App content to Home.jsx
// // import About from './About';
// //About
// import './index.css';
// import About from './Pages/About/About';
// import Home from './Pages/About/About';

// function App() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const NavLink = ({ to, children }) => (
//     <Link to={to} className="nav-link" onClick={() => setMobileMenuOpen(false)}>
//       {children}
//     </Link>
//   );

//   return (
//     <Router>
//       {/* Header - Updated with Router Links */}
//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="inner">
//           <Link to="/" className="logo">DevLearn Research</Link>
//           <nav className="nav-desktop">
//             <NavLink to="/services">Services</NavLink>
//             <NavLink to="/sectors">Sectors</NavLink>
//             <NavLink to="/case-studies">Case Studies</NavLink>
//             <NavLink to="/resources">Resources</NavLink>
//             <NavLink to="/about">About</NavLink>
//           </nav>
//           <div className="header-actions">
//             <NavLink to="/contact">Contact</NavLink>
//             <a href="#" className="cta-btn">Let's talk</a>
//           </div>
//           <button
//             className="mobile-toggle"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
//           </button>
//         </div>
//         <nav className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//           <NavLink to="/services">Services</NavLink>
//           <NavLink to="/sectors">Sectors</NavLink>
//           <NavLink to="/case-studies">Case Studies</NavLink>
//           <NavLink to="/resources">Resources</NavLink>
//           <NavLink to="/about">About</NavLink>
//           <NavLink to="/contact">Contact</NavLink>
//           <a href="#" className="cta-btn" style={{ display: 'inline-block', marginTop: '30px' }}>
//             Let's talk
//           </a>
//         </nav>
//       </header>

//       {/* Routes */}
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         {/* Add more routes as needed, e.g., <Route path="/services" element={<Services />} /> */}
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// import { useState, useEffect } from 'react';
// import { Menu, X, ArrowRight } from 'lucide-react';
// import './App.css';

// function App() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <>
//       {/* Header */}
//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="inner">
//           <a href="/" className="logo">DevLearn Research</a>

//           <nav className="nav-desktop">
//             <a href="#">Services</a>
//             <a href="#">Sectors</a>
//             <a href="#">Case Studies</a>
//             <a href="#">Resources</a>
//             <a href="#">About</a>
//           </nav>

//           <div className="header-actions">
//             <a href="#">Contact</a>
//             <a href="#" className="cta-btn">Let's talk</a>
//           </div>

//           <button
//             className="mobile-toggle"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
//           </button>
//         </div>

//         <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//           <a href="#">Services</a>
//           <a href="#">Sectors</a>
//           <a href="#">Case Studies</a>
//           <a href="#">Resources</a>
//           <a href="#">About</a>
//           <a href="#">Contact</a>
//           <a
//             href="#"
//             className="cta-btn"
//             style={{ display: 'inline-block', marginTop: '30px' }}
//           >
//             Let's talk
//           </a>
//         </div>
//       </header>

//       {/* Hero */}
//       <section className="hero">
//         <div>
//           <h1>Turning Data Into Decisions That Matter</h1>
//           <p>
//             We help organisations uncover DevLearns, evaluate impact, and design
//             strategies backed by evidence. Precise research. Clear direction.
//             Real results.
//           </p>

//           <div className="hero-buttons">
//             <a href="#" className="btn btn-primary">
//               Start a project <ArrowRight />
//             </a>
//             <a href="#" className="btn btn-secondary">
//               View our studies
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* Recognition */}
//       <section className="section text-center recognition">
//         <div className="container">
//           <h2>Trusted by Governments, NGOs & Leading Institutions</h2>
//           <div className="badge"></div>
//         </div>
//       </section>

//       {/* Hold the hype */}
//       <section className="hold-hype text-center">
//         <div className="container">
//           <h2>
//             Research that goes beyond numbers.<br />DevLearn that drives change.
//           </h2>
//           <p>Evidence, hold the guesswork.</p>
//         </div>
//       </section>

//       {/* Capabilities */}
//       <section className="section capabilities">
//         <div className="container text-center">
//           <h2 style={{ fontSize: '52px', marginBottom: '100px' }}>
//             Why organisations trust us
//           </h2>

//           <div className="cap-grid">
//             <div className="cap-card">
//               <div className="cap-image"></div>
//               <h3>Expert-Led Research</h3>
//               <p>
//                 From survey design to fieldwork and analysis, we deliver
//                 end-to-end research solutions built on global standards.
//               </p>
//             </div>

//             <div className="cap-card">
//               <div className="cap-image"></div>
//               <h3>Sector-Specific DevLearns</h3>
//               <p>
//                 Deep experience across education, health, finance, agriculture,
//                 and public policy — with contextualised DevLearns.
//               </p>
//             </div>

//             <div className="cap-card">
//               <div className="cap-image"></div>
//               <h3>Strategic Impact</h3>
//               <p>
//                 Our findings translate directly into decisions, policy,
//                 innovation, and actionable recommendations.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Stats */}
//       <section className="stats text-center">
//         <div className="stats-grid">
//           <div>
//             <div className="stat-number">500+</div>
//             <div className="stat-label">Completed Studies</div>
//           </div>
//           <div>
//             <div className="stat-number">20+</div>
//             <div className="stat-label">Research Countries</div>
//           </div>
//           <div>
//             <div className="stat-number">150+</div>
//             <div className="stat-label">Institutional Clients</div>
//           </div>
//           <div>
//             <div className="stat-number">98%</div>
//             <div className="stat-label">Client Satisfaction</div>
//           </div>
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="final-cta text-center">
//         <div className="container">
//           <h2>
//             Ready to understand what truly matters?<br />Let’s explore it together.
//           </h2>

//           <a href="#" className="btn btn-primary">
//             Start the conversation <ArrowRight size={28} />
//           </a>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="footer">
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo">DevLearn Research</div>
//           </div>

//           <div>
//             <h4>Services</h4>
//             <ul>
//               <li><a href="#">Market Research</a></li>
//               <li><a href="#">Impact Evaluation</a></li>
//               <li><a href="#">Data Analytics</a></li>
//             </ul>
//           </div>

//           <div>
//             <h4>Sectors</h4>
//             <ul>
//               <li><a href="#">Education</a></li>
//               <li><a href="#">Public Health</a></li>
//               <li><a href="#">Finance & Development</a></li>
//             </ul>
//           </div>

//           <div>
//             <h4>Company</h4>
//             <ul>
//               <li><a href="#">About</a></li>
//               <li><a href="#">Team</a></li>
//               <li><a href="#">Reports</a></li>
//             </ul>
//           </div>

//           <div>
//             <h4>Contact</h4>
//             <ul>
//               <li><a href="#">hello@DevLearnresearch.com</a></li>
//               <li><a href="#">Locations</a></li>
//             </ul>
//           </div>
//         </div>

//         <div className="copyright">
//           © 2025 DevLearn Research. All rights reserved.
//         </div>
//       </footer>
//     </>
//   );
// }

// export default App;


// import { useState, useEffect } from 'react';
// import { Menu, X, ArrowRight } from 'lucide-react';
// import './index.css';

// function App() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   return (
//     <>
//       {/* Header */}
//       <header className={`header ${scrolled ? 'scrolled' : ''}`}>
//         <div className="inner">
//           <a href="/" className="logo">DevL</a>

//           <nav className="nav-desktop">
//             <a href="#">Services</a>
//             <a href="#">Industries</a>
//             <a href="#">DevLearns</a>
//             <a href="#">Careers</a>
//             <a href="#">About</a>
//           </nav>

//           <div className="header-actions">
//             <a href="#">Contact</a>
//             <a href="#" className="cta-btn">Let's talk</a>
//           </div>

//           <button className="mobile-toggle" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
//             {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
//           </button>
//         </div>

//         <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
//           <a href="#">Services</a>
//           <a href="#">Industries</a>
//           <a href="#">DevLearns</a>
//           <a href="#">Careers</a>
//           <a href="#">About</a>
//           <a href="#">Contact</a>
//           <a href="#" className="cta-btn" style={{display: 'inline-block', marginTop: '30px'}}>Let's talk</a>
//         </div>
//       </header>

//       {/* Hero */}
//       <section className="hero">
//         <div>
//           <h1>Building tomorrow, together</h1>
//           <p>We partner with ambitious leaders to turn complex challenges into transformative growth using strategy, technology, and human ingenuity.</p>
//           <div className="hero-buttons">
//             <a href="#" className="btn btn-primary">Get started <ArrowRight /></a>
//             <a href="#" className="btn btn-secondary">See our work</a>
//           </div>
//         </div>
//       </section>

//       {/* Recognition */}
//       <section className="section text-center recognition">
//         <div className="container">
//           <h2>AWS Generative AI Partner of the Year – Global 2025</h2>
//           <div className="badge"></div>
//         </div>
//       </section>

//       {/* Hold the hype */}
//       <section className="hold-hype text-center">
//         <div className="container">
//           <h2>Think AI should be doing more for you by now?<br />So do we.</h2>
//           <p>AI, hold the hype.</p>
//         </div>
//       </section>

//       {/* Capabilities */}
//       <section className="section capabilities">
//         <div className="container text-center">
//           <h2 style={{fontSize: '52px', marginBottom: '100px'}}>The DevL experience</h2>
//           <div className="cap-grid">
//             <div className="cap-card">
//               <div className="cap-image"></div>
//               <h3>End-to-end delivery</h3>
//               <p>Strategy through execution — we bring the right mix of capabilities to accelerate your most ambitious goals.</p>
//             </div>
//             <div className="cap-card">
//               <div className="cap-image"></div>
//               <h3>Deep industry expertise</h3>
//               <p>Proven impact across your sector, combined with fresh perspectives from adjacent industries.</p>
//             </div>
//             <div className="cap-card">
//               <div className="cap-image"></div>
//               <h3>Exponential partnerships</h3>
//               <p>We co-create with 700+ leading technology partners to deliver breakthrough solutions at speed.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Stats */}
//       <section className="stats text-center">
//         <div className="stats-grid">
//           <div>
//             <div className="stat-number">13,000+</div>
//             <div className="stat-label">People worldwide</div>
//           </div>
//           <div>
//             <div className="stat-number">40+</div>
//             <div className="stat-label">Countries</div>
//           </div>
//           <div>
//             <div className="stat-number">90+</div>
//             <div className="stat-label">Fortune 100 clients</div>
//           </div>
//           <div>
//             <div className="stat-number">$2B+</div>
//             <div className="stat-label">Annual revenue</div>
//           </div>
//         </div>
//       </section>

//       {/* Final CTA */}
//       <section className="final-cta text-center">
//         <div className="container">
//           <h2>Let’s solve what’s next.<br />Together.</h2>
//           <a href="#" className="btn btn-primary">Start the conversation <ArrowRight size={28} /></a>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="footer">
//         <div className="footer-grid">
//           <div>
//             <div className="footer-logo">DevL</div>
//           </div>
//           <div>
//             <h4>Services</h4>
//             <ul><li><a href="#">AI & Data</a></li><li><a href="#">Cloud</a></li><li><a href="#">Customer Experience</a></li></ul>
//           </div>
//           <div>
//             <h4>Industries</h4>
//             <ul><li><a href="#">Financial Services</a></li><li><a href="#">Healthcare</a></li><li><a href="#">Energy</a></li></ul>
//           </div>
//           <div>
//             <h4>Company</h4>
//             <ul><li><a href="#">About</a></li><li><a href="#">Careers</a></li><li><a href="#">Newsroom</a></li></ul>
//           </div>
//           <div>
//             <h4>Contact</h4>
//             <ul><li><a href="#">hello@devl.com</a></li><li><a href="#">Locations</a></li></ul>
//           </div>
//         </div>
//         <div className="copyright">
//           © 2025 DevL. All rights reserved.
//         </div>
//       </footer>
//     </>
//   );
// }

// export default App;